import { Component, OnInit, Inject } from '@angular/core';
import { SaleTeamDetailInfo, SaleTeamInfo, SaleTeamManagementsInfo } from '../model/SaleTeamInfo.model';
import { environment } from 'src/environments/environment';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpEventType, HttpClient, HttpHeaders } from "@angular/common/http";
import { GlobalService } from '../service/global.service';
import { EmpInfo } from '../model/emp.model';
import { SaleTeamMappingEmployeeInfo } from '../model/SaleTeamMappingEmployeeInfo.model';
import { SaleOrderBacklogMappingEmpInfo } from '../model/SaleOrderBacklogMappingEmpInfo.model';
import { TokenService } from '../service/token.service';
import { TeamInfo } from '../model/team.model';
import { Observable } from 'rxjs';
import { data } from 'jquery';

@Component({
  selector: 'app-sale-team',
  templateUrl: './sale-team.component.html',
  styleUrls: ['./sale-team.component.css']
})
export class SaleTeamComponent implements OnInit {
  /************************* Variables ************************** */
  baseurl: string;
  _EmpCode: string;
  _CurTeamCode: string;

  txtSchTeamCode: string = "";
  txtSchTeamName: string = "";
  txtSchBacklogMappingEmpCode: string = "";
  txtSchBacklogMappingEmpName: string = "";

  txtSchEmpCode: string = "";
  txtSchEmpName: string = "";

  teamInfo: SaleTeamManagementsInfo = new SaleTeamManagementsInfo();
  teamForm: FormGroup;
  ListSaleTeams: SaleTeamManagementsInfo[] = [];
  ListEmpTeams: SaleTeamMappingEmployeeInfo[] = [];
  ListSaleEmpTeams: SaleTeamMappingEmployeeInfo[] = [];


  //New modal
  ListEmpTeamsSelected: SaleTeamMappingEmployeeInfo[] = [];
  ListEmpTeamsPool: SaleTeamMappingEmployeeInfo[] = [];
  ListEmpMapping: SaleTeamMappingEmployeeInfo[] = [];
  ListSaleOrderBacklogTeamMappingEmp: SaleOrderBacklogMappingEmpInfo[] = [];

  EmpCodeMapBacklogSelected: string = "";
  EmpNameMapBacklogSelected: string = "";

  //Pagination
  indexNo: number = 0
  currentPageNumber: number = 1;
  totalTeams: number = 0;
  totalPages: number = 0;
  pageSize: number = 5;

  totalEmps: number = 0;
  currentPageNumber_Emp: number = 1;
  totalPages_Emp: number = 0;


  totalEmpsSel: number = 0;
  currentPageNumber_EmpSel: number = 1;
  totalPages_EmpSel: number = 0

  currentPageNumber_EmpMapping: number = 1;
  totalPages_EmpMapping: number;
  totalItems: number = 0

  currentPageNumber_TeamMapping: number = 1;
  totalPages_TeamMapping: number;
  totalItemsSaleOrderBacklogMappingEmp: number = 0;

  //Loading
  displayloading: boolean = false;
  Msgloadding: string = '';

  //Modal
  titlemodal: string;
  detailmodal: string;
  /************************* End Variables ************************** */

  /************************* Functions ************************** */
  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder, private GlobalService: GlobalService, private TokenService: TokenService) {
    this.baseurl = environment.base_api;
    GlobalService.CheckPagingAccessRights();
  }
  ngOnInit() {
    this._EmpCode = localStorage.getItem("EmpCode");

    this.currentPageNumber = 1;
    this.pageSize = environment.PageSize;

    this.LoadSaleTeamList();
    this.LoadCountSaleTeamList().then(count => {
      this.SetTotalpagePagination(count);
    });


    this.teamForm = new FormGroup({
      TeamName: new FormControl(this.teamInfo.TeamName, [Validators.required]),
      TeamColor: new FormControl(this.teamInfo.TeamColor, [Validators.required]),
    });

  }

  get TeamName() { return this.teamForm.get('TeamName'); }
  get TeamColor() { return this.teamForm.get('TeamColor'); }


  async LoadSaleTeamList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.Loading(true, 'Loading...');

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * environment.PageSize;

      var objectjson = {};
      objectjson['TeamCode'] = this.txtSchTeamCode;
      objectjson['TeamName'] = this.txtSchTeamName;
      objectjson['rowFetch'] = environment.PageSize;
      objectjson['rowOFFSet'] = offset;

      let strjson = JSON.stringify(objectjson);

      this.httpClient
        .post<SaleTeamManagementsInfo[]>(this.baseurl + "Team/GetTeamCriteria",
          strjson, httpOptions)
        .subscribe({
          next: data => {
            this.ListSaleTeams = data;

            setTimeout(() => { this.Loading(false, ''); }, 500);
          }
        });
    }
  }

  async LoadCountSaleTeamList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['TeamCode'] = this.txtSchTeamCode;
      objectjson['TeamName'] = this.txtSchTeamName;
      let strjson = JSON.stringify(objectjson);

      return this.httpClient
        .post<number>(this.baseurl + "Team/GetCountTeamCriteria",
          strjson, httpOptions)
        .toPromise();
    }
  }

  async LoadSaleTeamDetail(teamId) {

    if (!!teamId) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = {};
        objectjson['TeamId'] = teamId;
        let strjson = JSON.stringify(objectjson);

        this.httpClient
          .post<SaleTeamManagementsInfo[]>(this.baseurl + "Team/GetTeamCriteria",
            strjson, httpOptions)
          .subscribe({
            next: data => {

              this.teamInfo = data[0];
              this.TeamName.setValue(data[0].TeamName);
              this.TeamColor.setValue(data[0].TeamColor);

            }
          });
      }
    }
  }

  async LoadEmployeesList(teamCode) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.Loading(true, 'Loading...');

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber_Emp - 1) * environment.PageSize;

      var objectjson = {};
      objectjson['SaleTeamCode'] = teamCode;
      objectjson['EmployeeCode'] = this.txtSchEmpCode;
      objectjson['EmployeeName'] = this.txtSchEmpName;
      objectjson['rowFetch'] = environment.PageSize;
      objectjson['rowOFFSet'] = offset;
      objectjson['UnAssignedSeller'] = true;

      let strjson = JSON.stringify(objectjson);

      this.httpClient
        .post<SaleTeamMappingEmployeeInfo[]>(this.baseurl + "Team/GetEmpMappingTeam",
          strjson, httpOptions)
        .subscribe({
          next: data => {
            this.ListEmpTeams = data;
            this.ListEmpTeamsPool = this.ListEmpTeams.filter(x => !x.IsTeam);;
            //this.ListEmpTeamsSelected = this.ListEmpTeams.filter(x => x.IsTeam);

            // console.log(this.ListEmpTeams)
            // console.log(this.ListEmpTeamsPool)
            // console.log(this.ListEmpTeamsSelected)

            setTimeout(() => { this.Loading(false, ''); }, 500);
          }
        });
    }
  }

  async LoadCountEmployeesList(teamCode) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['SaleTeamCode'] = teamCode;
      objectjson['EmployeeCode'] = this.txtSchEmpCode;
      objectjson['EmployeeName'] = this.txtSchEmpName;
      objectjson['UnAssignedSeller'] = true;
      let strjson = JSON.stringify(objectjson);

      return this.httpClient
        .post<number>(this.baseurl + "Team/GetCountEmpMappingTeam",
          strjson, httpOptions)
        .toPromise();
    }
  }


  async LoadSaleTeamEmployeesList(teamCode) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.Loading(true, 'Loading...');

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber_EmpSel - 1) * environment.PageSize;

      var objectjson = {};
      objectjson['SaleTeamCode'] = teamCode;
      // objectjson['EmployeeCode'] = this.txtSchEmpCode;
      // objectjson['EmployeeName'] = this.txtSchEmpName;
      objectjson['rowFetch'] = environment.PageSize;
      objectjson['rowOFFSet'] = offset;
      objectjson['AssignedSellerOnly'] = true;

      let strjson = JSON.stringify(objectjson);

      this.httpClient
        .post<SaleTeamMappingEmployeeInfo[]>(this.baseurl + "Team/GetEmpMappingTeam",
          strjson, httpOptions)
        .subscribe({
          next: data => {
            this.ListSaleEmpTeams = data;
            //this.ListEmpTeamsPool = this.ListEmpTeams.filter(x => !x.IsTeam);;
            this.ListEmpTeamsSelected = this.ListSaleEmpTeams.filter(x => x.IsTeam);

            // console.log(this.ListEmpTeamsPool)
            // console.log(this.ListEmpTeamsSelected)

            setTimeout(() => { this.Loading(false, ''); }, 500);
          }
        });
    }
  }

  async LoadCountSaleTeamEmployeesList(teamCode) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['SaleTeamCode'] = teamCode;
      // objectjson['EmployeeCode'] = this.txtSchEmpCode;
      // objectjson['EmployeeName'] = this.txtSchEmpName;
      objectjson['AssignedSellerOnly'] = true;
      let strjson = JSON.stringify(objectjson);

      return this.httpClient
        .post<number>(this.baseurl + "Team/GetCountEmpMappingTeam",
          strjson, httpOptions)
        .toPromise();
    }
  }



  OnSearch_Click() {
    this.currentPageNumber = 1;
    this.LoadSaleTeamList();
    this.LoadCountSaleTeamList();
  }
  OnClear_Click() {
    this.txtSchTeamCode = "";
    this.txtSchTeamName = "";
    this.currentPageNumber = 1;

    this.LoadSaleTeamList();
    this.LoadCountSaleTeamList();
  }

  OnSearchEmp_Click()
  {
    this.currentPageNumber_Emp = 1;
    this.LoadEmployeesList(this._CurTeamCode);
    this.LoadCountEmployeesList(this._CurTeamCode).then(count => {
      
      this.SetTotalpagePagination_Emp(count);
    });
  }
  OnClearEmp_Click() {
    this.txtSchEmpCode = "";
    this.txtSchEmpName = "";

    this.currentPageNumber_Emp = 1;
    this.LoadEmployeesList(this._CurTeamCode);
    this.LoadCountEmployeesList(this._CurTeamCode).then(count => {
      
      this.SetTotalpagePagination_Emp(count);
    });
  }

  OnCreateTeam_Click() {
    /*Clear old values */
    this.teamInfo = new SaleTeamManagementsInfo();
    this.TeamName.setValue(null);
    this.TeamColor.setValue(null);

    this.teamForm.markAsUntouched();
    this.teamForm.markAsPristine();

    $('#modalCreateTeamTitle').html('Create Sale Team');
    $('#modalCreateOrEditTeam').modal();
  }
  async OnSubmitCreateTeam_Click() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      if (this.teamForm.valid) {
        //Save to server
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = this.teamInfo;
        objectjson['TeamName'] = this.TeamName.value;
        objectjson['TeamColor'] = this.TeamColor.value;
        objectjson['CreateBy'] = this._EmpCode;

        let strjson = JSON.stringify(objectjson);

        this.httpClient
          .post<boolean>(this.baseurl + "Team/InsertSaleTeam",
            strjson, httpOptions)
          .subscribe({
            next: result => {
              if (result) {
                $('#ModalInsertComplate').modal();
                $('#modalCreateOrEditTeam').modal('hide');
              } else {
                console.log('insert fail');
              }
              this.RefreshTable();
            }
          });
        //End save to server
      } else {
        this.TeamName.markAsDirty();
        this.TeamName.markAsTouched();

        this.TeamColor.markAsDirty();
        this.TeamColor.markAsTouched();
      }
    }
  }

  chkallclick(traget) {
    var check = $(traget.currentTarget).is(":checked");
    $('[name="checkboxProjectSale"]').prop('checked', check);
  }

  deleteTeam(auth_token, id): Observable<TeamInfo[]> {
  
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };
    var objectjson = {};
    objectjson['TeamId'] = id;

    let strjson = JSON.stringify(objectjson);

    return this.httpClient.post<TeamInfo[]>(this.baseurl + "Team/DeleteSaleTeam", strjson, httpOptions);
}

async deleteTeamList(observableBatch: any[]) {
  var auth_token = await this.TokenService.RefreshToken();
  if (!!auth_token) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    let strjson = JSON.stringify(observableBatch);

    return this.httpClient.post<TeamInfo[]>(this.baseurl + "Team/DeleteListSaleTeam", strjson, httpOptions);
  }
}

  async OnDelete_Click(id) {
    if (confirm("Are you sure you want to delete this team ?")) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        console.log(id);
        this.deleteTeam(auth_token,parseInt(id)).toPromise()
          .then(
            data => {
              $('#ModalDeleteComplate').modal('show');
              this.currentPageNumber = 1;
              this.RefreshTable();
            }
            
          );
      }
    }
  }
  async OnDeleteList_Click() {
    if (confirm("Are you sure you want to delete these teams?")) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        var checkkedProjectSale = $('[name="checkboxProjectSale"]:checked');

        let num = checkkedProjectSale.length;
        let observableBatch = [];
        for (var i = 0; i < num; i++) {

          var ProjectTeamcurrent = <HTMLInputElement>checkkedProjectSale[i];
          observableBatch.push(this.deleteTeam(auth_token,parseInt(ProjectTeamcurrent.value)).toPromise().then(val => {
          }));
        }

        Promise.all(observableBatch).then(val => {

          this.deleteTeamList(observableBatch).then(
            data => {
              $('#ModalDeleteComplate').modal('show');
              this.currentPageNumber = 1;
              this.RefreshTable();
            }
          );

        });
      }
    }
  }
  async OnEdit_Click(teamId) {
    this.Loading(true, 'Loading...');
    await this.LoadSaleTeamDetail(teamId);

    setTimeout(() => {
      this.Loading(false, '');
      $('#modalCreateTeamTitle').html('Edit Sale Team');
      $('#modalCreateOrEditTeam').modal();
    }, 500);
  }
  async OnSubmitEdit_Click() {

    if (this.teamForm.valid) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        //Save to server
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = this.teamInfo;
        objectjson['TeamName'] = this.TeamName.value;
        objectjson['TeamColor'] = this.TeamColor.value;
        objectjson['UpdateBy'] = this._EmpCode;

        let strjson = JSON.stringify(objectjson);
        this.httpClient
          .post<boolean>(this.baseurl + "Team/UpdateSaleTeam",
            strjson, httpOptions)
          .subscribe({
            next: result => {
              if (result) {
                $('#ModalUpdateComplate').modal();
                $('#modalCreateOrEditTeam').modal('hide');
              } else {
                console.log('insert fail');
              }
              this.RefreshTable();
            }
          });
        //End save to server
      } else {
        this.TeamName.markAsDirty();
        this.TeamName.markAsTouched();

        this.TeamColor.markAsDirty();
        this.TeamColor.markAsTouched();
      }
    }
  }

  OnAddSalesToTeam_Click(teamCode) {
    this._CurTeamCode = teamCode;

    this.currentPageNumber_Emp = 1;
    this.LoadEmployeesList(teamCode);
    this.LoadCountEmployeesList(teamCode).then(count => {
      this.SetTotalpagePagination_Emp(count);
    });

    this.currentPageNumber_EmpSel = 1;
    this.LoadSaleTeamEmployeesList(teamCode);
    this.LoadCountSaleTeamEmployeesList(teamCode).then(count => {
      this.SetTotalpagePagination_EmpSel(count);
    });
    
    $('#modalAddSaleToTeam').modal();
  }
  async OnAddSaleToTeamChanges_Click(customList = null) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.Loading(true, 'Loading...');

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      // this.ListEmpTeams.forEach((item, idx) => {
      //   item.SaleTeamCode = this._CurTeamCode;
      //   item.CreateBy = this._EmpCode;
      //   item.UpdateBy = this._EmpCode;
      // });

      this.ListEmpTeamsSelected.forEach((item, idx) => {
        item.SaleTeamCode = this._CurTeamCode;
        item.CreateBy = this._EmpCode;
        item.UpdateBy = this._EmpCode;
      });

      var objectjson: SaleTeamMappingEmployeeInfo[] = [];

      if(customList === null || customList === undefined){
        objectjson = this.ListEmpTeamsSelected;
      } else {
        objectjson = customList;
      }


      let strjson = JSON.stringify(objectjson);

      this.httpClient
        .post<any>(this.baseurl + "Team/UpdateEmpMappingTeam",
          strjson, httpOptions)
        .subscribe({
          next: data => {
            

            if(customList === null || customList === undefined){
              //update config
              this.titlemodal = 'Saving team detail done.';
              this.detailmodal = 'Your team list was updated successfully.';
              $('#ModalComplate').modal();
              $('#modalAddSaleToTeam').modal('hide');
              setTimeout(() => { this.Loading(false, ''); }, 500);
            }else{
              //add/delete
              this.currentPageNumber_Emp = 1;
              this.LoadEmployeesList(this._CurTeamCode);
              this.LoadCountEmployeesList(this._CurTeamCode).then(count => {
                this.SetTotalpagePagination_Emp(count);
              });

              this.currentPageNumber_EmpSel = 1;
              this.LoadSaleTeamEmployeesList(this._CurTeamCode);
              this.LoadCountSaleTeamEmployeesList(this._CurTeamCode).then(count => {
                this.SetTotalpagePagination_EmpSel(count);
              });
            }
          }
        });
    }
  }

  btnClick_addMemberSales(){
    let selectedMems = this.ListEmpTeamsPool.filter(x => x.IsTeam);

    if(selectedMems){
      selectedMems.forEach((item, idx) => {
        item.SaleTeamCode = this._CurTeamCode;
        item.CreateBy = this._EmpCode;
        item.UpdateBy = this._EmpCode;
      });
  
      this.OnAddSaleToTeamChanges_Click(selectedMems);
    }
    
  }

  btnClick_delMemberSale(oneEmployeeItem){
    let selectedMems: SaleTeamMappingEmployeeInfo[] = [];
    if(oneEmployeeItem){
      oneEmployeeItem.IsTeam = false;
      oneEmployeeItem.SaleTeamCode = this._CurTeamCode;
      oneEmployeeItem.CreateBy = this._EmpCode;
      oneEmployeeItem.UpdateBy = this._EmpCode;
      selectedMems.push(oneEmployeeItem);

      this.OnAddSaleToTeamChanges_Click(selectedMems);
    }
    
  }

  //----- Private Functions
  Loading(flag: boolean, Msg: string = '') {
    this.displayloading = flag;
    this.Msgloadding = Msg;
  }

  OnLoadListFinished(traget = null) {
    if (traget != null) { // check call function from change page or onloadfrist
      this.currentPageNumber = traget.currentPageNumber;
      this.totalPages = traget.totalPages;
      this.indexNo = traget.index;
    }

    this.LoadSaleTeamList();
  }
  SetTotalpagePagination(data) {
    this.totalTeams = data;
    if(this.totalTeams == 0){
      this.currentPageNumber = 0;
    }
    this.totalPages = Math.ceil(this.totalTeams / environment.PageSize);
  }

  OnLoadListFinished_Emp(traget = null) {
    if (traget != null) { // check call function from change page or onloadfrist
      this.currentPageNumber_Emp = traget.currentPageNumber;
      this.totalPages_Emp = traget.totalPages;
      this.indexNo = traget.index;
    }

    this.LoadEmployeesList(this._CurTeamCode);
  }
  OnLoadListFinished_EmpSel(traget = null) {
    if (traget != null) { // check call function from change page or onloadfrist
      this.currentPageNumber_EmpSel = traget.currentPageNumber;
      this.totalPages_EmpSel = traget.totalPages;
      this.indexNo = traget.index;
    }

    //this.LoadEmployeesList(this._CurTeamCode);
    this.LoadSaleTeamEmployeesList(this._CurTeamCode);
  }


  SetTotalpagePagination_Emp(data) {
    this.totalEmps = data;
    if(this.totalEmps == 0){
      this.currentPageNumber_Emp = 0;
    }
    this.totalPages_Emp = Math.ceil(this.totalEmps / environment.PageSize);
  }

  SetTotalpagePagination_EmpSel(data) {
    this.totalEmpsSel = data;
    if(this.totalEmpsSel == 0){
      this.currentPageNumber_EmpSel = 0;
    }
    this.totalPages_EmpSel = Math.ceil(this.totalEmpsSel / environment.PageSize);
  }

  RefreshTable(){
    this.LoadSaleTeamList();
    this.LoadCountSaleTeamList().then(count => {
      this.SetTotalpagePagination(count);
    });
  }
  /************************* Functions ************************** */

  async OnSaleOrderBacklogConfig_Click() {
    this.ListSaleOrderBacklogTeamMappingEmp = [];
    this.currentPageNumber_TeamMapping = 0;
    this.totalPages_TeamMapping = 0;

    this.EmpCodeMapBacklogSelected = "";
    this.EmpNameMapBacklogSelected = "";
    this.totalItemsSaleOrderBacklogMappingEmp = 0;

    this.txtSchBacklogMappingEmpCode = "";
    this.txtSchBacklogMappingEmpName = "";
    await this.LoadListEmpMapping("Y");

    $('#modalAddSaleBacklogMappingEmp').modal();
  }

  async LoadListEmpMapping(bySearch: string | null = null) {
    //this.loading = true;
    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        console.error('No valid token');
        alert('Session expired. Please login again.');
        return;
      }

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      if (bySearch === "Y") {
        this.currentPageNumber_EmpMapping = 1;
      }

      const objectjson = {
        EmployeeCode: this.checkUndefinedString(this.txtSchBacklogMappingEmpCode?.trim()),
        EmployeeName: this.checkUndefinedString(this.txtSchBacklogMappingEmpName?.trim()),
        rowFetch: environment.PageSize,
        rowOFFSet: ((this.currentPageNumber_EmpMapping - 1) < 0 ? 0 : (this.currentPageNumber_EmpMapping - 1)) * environment.PageSize
      };

      const response = await this.httpClient.post<any>(this.baseurl + "Team/GetAllEmployeeForMappingTeam",
        JSON.stringify(objectjson), httpOptions).toPromise();

      this.ListEmpMapping = response;
      //this.totalItems = this.ListEmpMapping.length;

      if (this.ListEmpMapping.length <= 0) {
        this.currentPageNumber_EmpMapping = 0;
      } else {
        if (this.currentPageNumber_EmpMapping == 0) this.currentPageNumber_EmpMapping = 1;
        this.totalItems = Number(this.ListEmpMapping[0].itemTotal);
      }

      this.totalPages_EmpMapping = Math.ceil(this.totalItems / environment.PageSize);
    } catch (error) {
      console.error('Error loading ListEmpMapping:', error);
      alert('An error occurred while loading ListEmpMapping data. Please try again.');
    } finally {
      //this.loading = false;
    }
  }

  OnLoadListFinished_EmpMapping(target = null) {
    if (target != null) {
      this.currentPageNumber_EmpMapping = target.currentPageNumber;
      this.totalPages_EmpMapping = target.totalPages;
      this.indexNo = target.index;
    }

    this.LoadListEmpMapping();
  }

  OnSearchEmpBacklogMapping_Click() {
    this.LoadListEmpMapping("Y");
  }

  async OnClearEmpBacklogMapping_Click() {
    this.txtSchBacklogMappingEmpCode = "";
    this.txtSchBacklogMappingEmpName = "";

    this.ListSaleOrderBacklogTeamMappingEmp = [];
    this.currentPageNumber_TeamMapping = 0;
    this.totalPages_TeamMapping = 0;

    this.EmpCodeMapBacklogSelected = "";
    this.EmpNameMapBacklogSelected = "";
    this.totalItemsSaleOrderBacklogMappingEmp = 0;

    await this.LoadListEmpMapping("Y");
  }

  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput
  }

  async btnClick_onViewEmpMapping(empCode, empName) {
    //console.log('empCode', empCode);
    this.ListSaleOrderBacklogTeamMappingEmp = [];

    this.EmpCodeMapBacklogSelected = empCode;
    this.EmpNameMapBacklogSelected = empName;

    await this.LoadListSaleOrderBacklogTeamMappingEmp("Y");
  }

  async LoadListSaleOrderBacklogTeamMappingEmp(bySearch: string | null = null) {
    try {
      const auth_token = await this.TokenService.RefreshToken();
      if (!auth_token) {
        console.error('No valid token');
        alert('Session expired. Please login again.');
        return;
      }

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      if (bySearch === "Y") {
        this.currentPageNumber_TeamMapping = 1;
      }

      const objectjson = {
        EmployeeCode: this.checkUndefinedString(this.EmpCodeMapBacklogSelected?.trim()),
        rowFetch: environment.PageSize,
        rowOFFSet: ((this.currentPageNumber_TeamMapping - 1) < 0 ? 0 : (this.currentPageNumber_TeamMapping - 1)) * environment.PageSize
      };

      const response = await this.httpClient.post<any>(this.baseurl + "Team/GetAllSaleOrderBacklogMappingEmp",
        JSON.stringify(objectjson), httpOptions).toPromise();

      this.ListSaleOrderBacklogTeamMappingEmp = response;
      console.log('ListSaleOrderBacklogTeamMappingEmp', this.ListSaleOrderBacklogTeamMappingEmp);
      //this.totalItems = this.ListSaleOrderBacklogTeamMappingEmp.length;

      if (this.ListSaleOrderBacklogTeamMappingEmp.length <= 0) {
        this.currentPageNumber_TeamMapping = 0;
      } else {
        if (this.currentPageNumber_TeamMapping == 0) this.currentPageNumber_TeamMapping = 1;
        this.totalItemsSaleOrderBacklogMappingEmp = Number(this.ListSaleOrderBacklogTeamMappingEmp[0].itemTotal);
      }

      this.totalPages_TeamMapping = Math.ceil(this.totalItemsSaleOrderBacklogMappingEmp / environment.PageSize);
    } catch (error) {
      console.error('Error loading ListSaleOrderBacklogTeamMappingEmp:', error);
      alert('An error occurred while loading ListSaleOrderBacklogTeamMappingEmp data. Please try again.');
    } finally {
      //this.loading = false;
    }
  }

  OnLoadListFinished_TeamMapping(target = null) {
    if (target != null) {
      this.currentPageNumber_TeamMapping = target.currentPageNumber;
      this.totalPages_TeamMapping = target.totalPages;
      this.indexNo = target.index;
    }

    this.LoadListEmpMapping();
  }

  async OnAddSaleTeamMappingEmpChanges_Click() {
    try {
    const auth_token = await this.TokenService.RefreshToken();
    if (!auth_token) {
      alert('Session expired. Please login again.');
      return;
    }

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    const strjson = this.ListSaleOrderBacklogTeamMappingEmp.map(e => ({
      EmployeeCode: e.EmployeeCode,
      TeamCode: e.TeamCode,
      FlagBacklogAccess: e.FlagBacklogAccess || 'N' // default 'N' if null
    }));

    const result = await this.httpClient
      .post<boolean>(this.baseurl + 'Team/UpdateSaleOrderBacklogMappingEmp', strjson, httpOptions)
      .toPromise();

    if (result) {
      alert('Update completed successfully.');
      await this.LoadListSaleOrderBacklogTeamMappingEmp("Y"); // reload list after update
    } else {
      alert('Update failed.');
    }

  } catch (err) {
    console.error('Update failed', err);
  }
  }
}
